/**
 * @Description 商圈详情头部部分
 */
import { FC, useMemo, useContext } from 'react';
import { Button, Typography } from 'antd';
import styles from './index.module.less';
import cs from 'classnames';
import { useMethods } from '@lhb/hook';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import copy from 'copy-to-clipboard';
import { getCookie } from '@lhb/cache';
import IconFont from '@/common/components/IconFont';
import { getShareId } from '@/common/api/common';
import { SpotTypeEnum } from '../../../../ts-config';
import UserInfoContext from '@/layout/context';
import ReportLogo from '@/common/components/business/AreaDetailDrawer/components/ReportLogo';
import { bigdataAction, } from '@/common/utils/bigdata';

const { Text } = Typography;

const Top: FC<any> = ({
  detail,
  drawerData,
  tenantId,
  configSwitch,
  // isSemirModel
}) => {
  const { tenantInfo: {
    globalAliasItemVOs,
    standardChancePointReportLogo: reportLogo,
    id: targetTenantId, // 非分享页时
  },
  id: employeeId, // 非分享页时
  } = useContext(UserInfoContext); // 租户信息

  const address = useMemo(() => {
    const {
      centerAddress,
      provinceName,
      cityName,
      districtName
    } = detail || {};
    let str = '';
    if (provinceName && provinceName !== cityName) {
      str += provinceName;
    }
    if (cityName) str += cityName;
    if (districtName) str += districtName;
    if (centerAddress) str += centerAddress;
    return str;
  }, [detail]);

  const methods = useMethods({
    onShare() {
      const currentTenantId = getCookie('tenantId') || targetTenantId;
      const userId = getCookie('employeeId') || employeeId;
      const { lng, lat, cityId, cityName, poiName, type, modelClusterId, modelConfigId, radius } = drawerData;
      getShareId({
        longLinkUrl: `${process.env.CONSOLE_PC_URL}/spotevaluation/detail`,
        content: JSON.stringify({ lng, lat, cityId, cityName, poiName, type, modelClusterId, modelConfigId, tenantId: currentTenantId,
          globalAliasItemVOs,
          reportLogo,
          radius,
          configSwitch,
          userId,
          // isSemirModel
        }),
      }).then((res: any) => {
        const op_event = type === SpotTypeEnum.Street ? `${cityName}_${poiName}_${radius}m` : `${cityName}_${poiName}`;
        // /spotevaluation/history?modelConfigId=23 查询例如跳转页未配置菜单，写死op_feat，op_menu
        bigdataAction('6c139683-db67-474d-ae67-4ca368cbd261', 'spotEvaluation',
          '点位测评', '点位测评详情页-分享', '点击了点位测评详情页-分享', { op_block: '', op_event: op_event, });
        V2Message.success('链接已复制，可直接发送给你的朋友');
        // copy(res.frontShareLinkUrl);
        // https://gitlab.lanhanba.com/fe/treasure/-/issues/102
        setTimeout(() => {
          copy(`${detail.areaName}：${res.frontShareLinkUrl}`);
        }, 0);
      });
    }
  });

  return (
    <div className={cs(styles.topCon, tenantId && styles.isShare)}>
      <div className={styles.titleRow}>
        <Text
          style={{ width: '100%' }}
          ellipsis={{ tooltip: detail.areaName }}>
          <span className={styles.title}>
            { drawerData.type === SpotTypeEnum.Street ? '街边店 - ' : '商场店 - ' }{detail.areaName}
          </span>
        </Text>
        { !!detail.centerAddress && (
          <Text
            style={{ width: '100%' }}
            ellipsis={{ tooltip: address }}>
            <div className={styles.subTitle}>
              <IconFont iconHref='iconIC_dizhi' className={styles.subTitleIcon} />
              { address }
            </div>
          </Text>
        ) }
      </div>
      {/* 分享页显示logo，非分享页显示分享按钮 */}
      { tenantId ? (
        <ReportLogo
          tenantId={tenantId}
          tenantLogo={drawerData.reportLogo}
          className='pt-3'
        />
      ) : (
        <div className={styles.flexCon}>
          <Button
            className='inline-block mr-8'
            onClick={methods.onShare}
          >
              分享
          </Button>
        </div>
      ) }
    </div>
  );
};

export default Top;
